import { IVFSResponse } from '../types';
import BaseAPI from '../BaseAPI';
import { ChartMogulEnrichData, ChartMogulEnrichResponse } from './types';

/**
 * Tracking API
 * Handles analytics and tracking operations
 */
class TrackingAPI extends BaseAPI {
  /**
   * Enrich ChartMogul data
   * @param data - Data to enrich
   */
  async enrichChartMogul(
    data: ChartMogulEnrichData[]
  ): Promise<IVFSResponse<ChartMogulEnrichResponse>> {
    return this.wrapResponse<ChartMogulEnrichResponse>({
      promise: this.apiInstance.post(
        '/v2/tracking/chart-mogul/enrich-data',
        data
      ),
      errorMessage: 'Failed to enrich ChartMogul data',
    });
  }
}

export default TrackingAPI;
